import { Screen } from "flemo";
import { useState } from "react";

import { AuthGuard } from "@/components/AuthGuard";
import { BottomNav } from "@/components/BottomNav";
import { PaywallDialog } from "@/components/PaywallDialog";
import { useIsPlusQuery } from "@/hooks/queries";
import { trackEvent } from "@/lib/analytics";

import { DailyQuote } from "./_components/DailyQuote";
import { Header } from "./_components/Header";
import { QuickStats } from "./_components/QuickStats";
import { SetProgress } from "./_components/SetProgress";
import { SmartReviewCard } from "./_components/SmartReviewCard";
import { StudyCTA } from "./_components/StudyCTA";
import { StudyStreak } from "./_components/StudyStreak";
import { WeeklyChart } from "./_components/WeeklyChart";

export function MainPage() {
  const { data: isPlus = false } = useIsPlusQuery();
  const [paywallOpen, setPaywallOpen] = useState(false);

  return (
    <AuthGuard>
      <Screen sharedNavigationBar={<BottomNav />}>
        <main className="h-dvh overflow-hidden bg-primary-background pt-safe">
          <Header />

          <section className="mx-auto flex h-full min-h-0 max-w-3xl flex-col gap-4 overflow-y-auto overscroll-none px-5 pb-[calc(144px+env(safe-area-inset-bottom,0px))] scrollbar-hidden">
            <DailyQuote />

            <StudyCTA />
            <SmartReviewCard />

            <QuickStats />
            <SetProgress />
            <StudyStreak />
            <WeeklyChart
              isLocked={!isPlus}
              onLockedClick={() => {
                trackEvent("paywall_triggered", { source: "weekly_chart" });
                setPaywallOpen(true);
              }}
            />
          </section>
        </main>

        <PaywallDialog open={paywallOpen} onOpenChange={setPaywallOpen} source="weekly_chart" />
      </Screen>
    </AuthGuard>
  );
}
